import N8nTableBase from './TableBase.vue';

export default N8nTableBase;
